module.exports = __webpack_public_path__ + "media/images/flags/um-0f5d59d436cb8d91444b8cbe055abc3a.svg";